function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.4 74.1H33.2H58.7L66.5 89.9H90.6V0.5H0V90.4H24.5L32.4 74.1Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.6 94.3H0V116.8H90.6V94.3Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M170 115.6L168.6 111.4H160.1L158.7 115.6H153.8L162.5 91.7002H166.2L174.9 115.6H170ZM164.4 98.8002L161.4 107.5H167.3L164.4 98.8002Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M209.1 115.6V91.7002H213.8V111.4H224.6V115.6H209.1V115.6Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M261.6 115.6V91.7002H266.3V111.4H277.1V115.6H261.6V115.6Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M319.6 115.6V91.7002H324.3V115.6H319.6Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M380.099 115.6L378.699 111.4H370.199L368.799 115.6H363.899L372.599 91.7002H376.299L384.999 115.6H380.099ZM374.599 98.8002L371.599 107.5H377.499L374.599 98.8002Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M432 115.6L422.5 100.9V115.6H417.8V91.7002H422L431.5 106.3V91.7002H436.2V115.6H432Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M479.5 115.8C476.9 115.8 474.8 114.9 473.1 113.2C472.1 112.2 471.4 111 471.2 109.6C470.9 108.3 470.8 106.3 470.8 103.7C470.8 101.1 470.9 99.1001 471.2 97.8001C471.5 96.4001 472.1 95.3001 473.1 94.2001C474.8 92.5001 477 91.6001 479.5 91.6001C484.1 91.6001 487.5 94.3001 488.3 99.2001H483.6C483.1 97.2001 481.8 95.8001 479.6 95.8001C478.3 95.8001 477.3 96.2001 476.6 97.0001C475.6 98.0001 475.4 99.1001 475.4 103.7C475.4 108.3 475.6 109.4 476.6 110.4C477.3 111.2 478.3 111.6 479.6 111.6C481.8 111.6 483.1 110.3 483.6 108.2H488.3C487.5 113.1 484.1 115.8 479.5 115.8Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M524.2 115.6V91.7002H539.9V95.9002H528.8V101.5H538.2V105.7H528.8V111.5H539.9V115.7H524.2V115.6Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M140.5 76.6V44.5H114.6V76.6H99.5996V0H114.6V31.3H140.5V0H155.5V76.6H140.5Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M246.7 76.5999L234.9 52.5H226.4V76.5999H214.6V16.2H238.3C250.6 16.2 257.9 24.6 257.9 34.7C257.9 43.2 252.7 48.3999 246.9 50.5999L260.4 76.5999H246.7ZM237.5 26.7H226.4V42.5999H237.5C242.7 42.5999 246.1 39.2999 246.1 34.5999C246.1 29.9999 242.7 26.7 237.5 26.7Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M305.7 70.8C301.7 74.8 296 76.5999 289.8 76.5999H268V16.2H289.8C296.1 16.2 301.8 18 305.7 22C312.5 28.8 311.8 37.1 311.8 46.2C311.9 55.2 312.5 64.1 305.7 70.8ZM297.5 30.5C295.5 28 292.7 26.7999 288.7 26.7999H279.8V66.1999H288.7C292.8 66.1999 295.5 64.9 297.5 62.5C299.7 59.8 300 55.4999 300 46.2999C300.1 36.9999 299.7 33.2 297.5 30.5Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M371.9 76.6L368.3 65.9H340L336.4 76.6H324L347.7 0.800049H360.4L384.2 76.6H371.9ZM354.3 18.6L343.3 56H365.2L354.3 18.6Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M473.5 76.5999V16.2H509.9V26.7H485.3V40.9H505.7V51.4H485.3V66.0999H509.9V76.5999H473.5Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M560.6 16.2H515.7V26.7H531.5V76.5999H543.3V26.7H554.2C555.3 22.6 557.5 19.1 560.6 16.2Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M578.8 77.0999C569.6 77.0999 562.7 75.1999 556.7 69.0999L564.3 61.5C568.1 65.3 573.3 66.5999 578.9 66.5999C585.9 66.5999 589.6 63.9999 589.6 59.0999C589.6 56.9999 589 55.2 587.7 54C586.5 52.9 585.2 52.3 582.4 51.9L575.1 50.9C569.9 50.1 566.1 48.5 563.4 45.9C560.5 43 559.1 39.1 559.1 34C559.1 23.2 567.1 15.7 580.1 15.7C588.4 15.7 594.4 17.7 599.6 22.7L592.1 30.1C588.3 26.5 583.7 25.9 579.7 25.9C573.4 25.9 570.4 29.4 570.4 33.5C570.4 35 570.9 36.5999 572.2 37.7999C573.4 38.8999 575.3 39.8 577.8 40.2L584.9 41.2C590.4 42 593.9 43.5 596.4 45.9C599.6 49 601.1 53.4 601.1 58.7C601.2 70.5 591.4 77.0999 578.8 77.0999Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M462.4 46C459.9 43.6 456.4 42.1 450.9 41.3L443.8 40.3C441.3 40 439.4 39.0001 438.2 37.9001C436.9 36.7001 436.4 35.1 436.4 33.6C436.4 29.4 439.5 26 445.7 26C449.7 26 454.3 26.5 458.1 30.2L465.6 22.8C460.4 17.8 454.4 15.8 446.1 15.8C433 15.8 425.1 23.4 425.1 34.1C425.1 39.2 426.5 43.1 429.4 46C432.1 48.6 435.9 50.2 441.1 51L448.4 52C451.2 52.4 452.6 53 453.7 54.1C455 55.3 455.6 57.1001 455.6 59.2001C455.6 64.0001 451.9 66.7 444.9 66.7C439.3 66.7 434.1 65.4 430.3 61.6C429.9 65.6 428.5 69.2001 426.4 72.3001C431.5 75.9001 437.4 77.2 444.7 77.2C457.3 77.2 467.1 70.6001 467.1 58.9001C467.1 53.5001 465.6 49 462.4 46Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M418.9 46C416.4 43.6 412.9 42.1 407.4 41.3L400.3 40.3C397.8 40 395.9 39.0001 394.7 37.9001C393.4 36.7001 392.9 35.1 392.9 33.6C392.9 29.4 396 26 402.2 26C406.2 26 410.8 26.5 414.6 30.2L422.1 22.8C416.9 17.8 410.9 15.8 402.6 15.8C389.5 15.8 381.6 23.4 381.6 34.1C381.6 39.2 383 43.1 385.9 46C388.6 48.6 392.4 50.2 397.6 51L404.9 52C407.7 52.4 409.1 53 410.2 54.1C411.5 55.3 412.1 57.1001 412.1 59.2001C412.1 64.0001 408.4 66.7 401.4 66.7C395.8 66.7 390.6 65.4 386.8 61.6L386.6 61.8L391.2 74.3001L391.9 76.2C394.8 76.8 397.8 77.1 401.2 77.1C413.8 77.1 423.6 70.5 423.6 58.8C423.5 53.5 422.1 49 418.9 46Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M187.2 16.2H178L162.5 58.7999V76.5999H168.3L171.9 65.9H193.4L197 76.5999H209.3L187.2 16.2ZM175.3 56L182.9 34L190.3 56H175.3Z",
  fill: "currentColor"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 601.2,
  height: 116.8,
  fill: "currentColor"
})));

var SvgHardAssetsAllianceLogo = function SvgHardAssetsAllianceLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 602 117",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHardAssetsAllianceLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/HardAssetsAllianceLogo.0f09cbf6.svg";
export { ForwardRef as ReactComponent };